<template>
  <!-- prettier-ignore -->
  <div class="person">
    <div class="person-group">
      <ovp-date-input
        v-model="value.personData.dateOfBirth"
        class="person__input person__dob"
        is-active
        name="dateOfBirth"
        :autofocus="autofocus && !value.personData.dateOfBirth"
        :delay="0"
        :theme="theme"
        :title="$t('person.birthdate')"
        :validate="v.personData.dateOfBirth"
      />

      <ovp-text-input
        v-model="value.personData.firstName"
        class="person__input person__name"
        is-active
        name="firstName"
        :placeholder="$t('person.person', { number: index + 1 })"
        :theme="theme"
        :title="$t('person.firstname')"
        :validate="v.personData.firstName"
      />

      <ovp-gender
        v-model="value.personData.gender"
        class="person__input person__gender"
        name="gender"
        :age="age"
        :validate="v.personData.gender"
      />

      <ovp-button
        v-show="value.personData.dateOfBirth || index > 0"
        class="person__delete"
        plain
        @click="$emit('delete')">
        <ovp-icon
          name="trash"
          art="solid"
        />
      </ovp-button>
    </div>

    <div
      v-if="groups.length > 0"
      class="person-group">
      <ovp-drop-down
        v-model="value.collectivePersonGroup"
        required
        class="person__input person__groups"
        name="collectivePersonGroup"
        :options="groups"
        :validate="v.collectivePersonGroup"
        :theme="theme"
        :title="$t('person.collective.group')"
      />
    </div>
  </div>
</template>

<script>
import { DateTimeHelper } from '@/helpers'
import { isNil } from 'lodash'

export default {
  name: 'Person',

  model: {
    prop: 'value',
    event: 'update',
  },

  props: {
    autofocus: {
      type: Boolean,
      default: false,
    },

    index: {
      type: Number,
      required: true,
    },

    personGroups: {
      type: Array,
      default: () => [],
    },

    theme: {
      type: String,
      default: 'light',
    },

    v: {
      type: Object,
      required: true,
    },

    value: {
      type: Object,
      required: true,
    },
  },

  watch: {
    age(newValue) {
      const firstName = this.value.personData.firstName
      if (newValue < 0 && (isNil(firstName) || firstName === '')) {
        this.value.personData.firstName = this.$t('person.defaultBabyName')
      }
    },
  },

  computed: {
    age() {
      return DateTimeHelper.getAge(this.value.personData.dateOfBirth)
    },

    groups() {
      return this.personGroups.map(group => {
        return {
          value: group.groupNumber,
          text: group.name,
        }
      })
    },
  },
}
</script>

<style name="mobile" scoped>
.person {
  padding: 10px;
  margin: 20px 0 0 0;
  background-color: var(--c-white);

  &__input {
    margin: 0 0 20px 0;
  }

  &__groups {
    margin: 20px 0 0 0;
  }

  &__delete,
  button.person__delete {
    font-size: 20px;
    margin: 0;
    justify-content: flex-end;

    &:hover .icon {
      color: var(--c-sanitas-green);
    }
  }
}
</style>

<style name="desktop" scoped>
@media (--md) {
  .person {
    padding: 20px 0 0 0;
    margin: 0;
    background-color: transparent;

    &-group {
      display: grid;
      grid-gap: 20px;
      grid-template-columns: 250px 250px 200px 1fr;
      grid-template-areas: 'dob name gender delete';

      height: 70px;
    }

    &__delete,
    button.person__delete {
      justify-content: center;
    }
  }
}
</style>
